// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1rZbb","cell":"ColumnAccessor_cell__3VTFd","firstCellAccent":"ColumnAccessor_firstCellAccent__2IAzf"};